export default __webpack_public_path__ + "static/media/logo_marianne.5b8170c4.png";